/*------------------------------------*\
    select
\*------------------------------------*/

module.exports = function(){

    $('.js-select2').select2();

    $('.js-select2').each(function(index, el) {
        $(el).val( $(el).attr('data-value') ).change();
    });


}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/select2.js